<template>
  <div class="footer" >
    <keep-alive>
      <van-tabbar
        class="pageCarServeShadow"
        :zIndex="1000"
        :value="active"
        safe-area-inset-bottom
        active-color="var(--depYelColor)"
        inactive-color="#aaa"
      >
        <!-- <van-tabbar-item to="/index">
          <span>服务首页</span>
          <div
            class="pageBgBlock icons"
            :class="active === 0 ? 'active' : ''"
            slot="icon"
          >
            <i class="iconfont iconhome"></i>
          </div>
        </van-tabbar-item> -->
        <van-tabbar-item to="/coupons">
          <span>我的卡券</span>
          <div
            class="pageBgBlock icons"
            :class="active === 0 ? 'active' : ''"
            slot="icon"
          >
            <i class="iconfont iconcoupons_fill"></i>
          </div>
        </van-tabbar-item>
        <van-tabbar-item to="/user">
          <span>个人中心</span>
          <div
            class="pageBgBlock icons"
            :class="active === 1 ? 'active' : ''"
            slot="icon"
          >
            <i class="iconfont iconuser"></i>
          </div>
        </van-tabbar-item>
      </van-tabbar>
    </keep-alive>
  </div>
</template>                                                                                                                               

<script>
/*global $ */
export default {
  props: {},
  data() {
    return {
      oldSystemDate: "",
      isShow: false,
      showFooter:false,
    };
  },

  mounted() {
  },
  methods: {
  },
  computed: {
    active() {
      let name = this.$route.name;
      if (name == null) {
        let pathname = location.pathname.replace("/", "");
        if (pathname != "")
          name = pathname.charAt(0).toUpperCase() + pathname.slice(1);
      }
      let val;
      switch (name) {
        // case "Index":
        //   val = 0;
        //   break;
        case "Coupon":
          val = 0;
          break;
        case "User":
          val = 1;
          break;
        default:
          val = -1;
      } 
      return val;
    },
  },
};
</script>

<style scoped lang="less">
.loading {
  z-index: 9999;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  height: 100%;
  width: 100%;
  margin: 0;
  background-color: white;
  border: 1px solid #fff;
  div {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    span {
      color: var(--depYelColor);
    }
  }
  h5 {
    color: var(--depYelColor);
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
}
/deep/ .van-dialog {
  .van-dialog__content {
    padding: 20px;
    .van-dialog__message {
      font-size: 16px;
    }
  }
}
.footer {
  .changeCoupons {
    z-index: 999;
    position: fixed;
    bottom: 60px;
    text-align: center;
    width: 100%;
    border-top: 1px solid #eee;
    padding: 5px 0;
    height: 65px;
    padding-bottom: env(safe-area-inset-bottom);
  }
  .changeCoupons p {
    text-align: center;
    font-size: 12px;
    line-height: 22px;
  }
  .changeCoupons .van-button--small {
    width: 100px;
    height: 32px;
    margin: 5px 0;
    padding: 0 8px;
    /* bottom: 15px; */
    /* right: 5px; */
    font-size: 14px;
    position: initial;
    min-width: 90%;
  }
  .changeCoupons .van-button:active::before {
    opacity: 0;
  }
  .van-tabbar {
    height: 60px;
  }
  .van-tabbar-item {
    font-size: 11px;
    font-weight: 700;
  }
  .icons {
    width: 26px;
    height: 26px;
    background: #aaa;
    .iconfont {
      color: #fff;
      font-size: 16px;
      margin-left: 1px;
    }
  }
  .active {
    background: var(--depYelColor);
  }
}
// //底部图标大小调整
// .iconuser{ font-size:18px;}
</style>
